import { Contact } from "../../components/contact";
import { Navigation } from "../../components/navigation";
import "./container-layout.styles.css";

export const ContainerLayout = ({ children }) => {
  return (
    <div className="rootContainerLayout">
      <Navigation />
      {children}
      <Contact mt />
    </div>
  );
};
